module.exports = __webpack_public_path__ + "img/marker-point-purpura-oscuro.5a084695.png";